import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { CMA_SUPPORT_URL } from '../apiConfig'

export const fetchDefaultQuestion = createAsyncThunk(
  'fetchDefaultQuestion',
  async ({ jwtBearer, category_id }) => {
    const response = await fetch(`${CMA_SUPPORT_URL}get/default/ticket/question/?category_id=${category_id}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
      }
    })
    return response.json()
  }
)

const DefaultQuestionSlice = createSlice({
  name: 'DefaultQuestionSlice',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchDefaultQuestion.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchDefaultQuestion.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchDefaultQuestion.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default DefaultQuestionSlice.reducer
